import React, { Component } from "react";
import hornos from "../../res/iconos/hornos.png";
import anafes from "../../res/iconos/anafes.png";
import campanas from "../../res/iconos/campanas.png";

import { Link } from "react-router-dom";

class Coccion extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

  render() {
    const mobile =
      window.innerWidth * 0.8 < 630;
    return (
      <div style={{ }}>
        {!mobile && 
        <img
          src={require("../../res/banners/coccion_desktop.png")}
          style={{
            position: "relative",
            objectFit: "cover",
            objectPosition: "center",
            width: "100%",
            //height: 368,
            zIndex: -1,
          }}
        />
        }
        
        <div style={{ width: "100%", height: "2vw" }} />
        <p className="coccion_texto">Con soluciones enfocadas en el ahorro energético y la versatilidad, esta colección fusiona innovación y responsabilidad ambiental. Cociná con tranquilidad, sabiendo que cada detalle está optimizado para tu confort.</p>
        <div style={{ width: "100%", height: "1.5vw" }} />
        <h1 className="coccion_titulo">Nuestros productos</h1>
        <div style={{ width: "100%", height: "3vw" }} />

        <div style={{width: "100%", marginLeft: "auto", marginRight: "auto", display: "flex", justifyContent: "space-between", justifyItems: "center", alignContent: "stretch", gap: 0, flexWrap: "wrap"}}>
          <Link to="/hornos" style={{flex: 1, width: "33%", minWidth: 100, margin: "auto"}}>
            <img className="coccion_boton" src={hornos}/>
          </Link>
          <Link to="/anafes" style={{flex: 1, width: "33%", minWidth: 100, margin: "auto"}}>
            <img className="coccion_boton" src={anafes}/>
          </Link>
          <Link to="/campanas" style={{flex: 1, width: "33%", minWidth: 100, margin: "auto"}}>
            <img className="coccion_boton" src={campanas}/>
          </Link>
        </div>
    </div>
    );
  }
}

export default Coccion;
